import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { SignalingMessage } from '../../models/models'
//import 'rxjs/add/operator/map';

import { ConfigProvider } from '../../providers/config/config'
/*
import {CondominiumProvider} from '../../providers/condominium/condominium';
import {HousingUnitProvider} from '../../providers/housing-unit/housing-unit';
*/

import { Condominium, HousingUnit, User, AccountType } from '../../models/models'
import { Logger } from '../../util/logger/logger'




@Injectable()
export class UserProvider {
	constructor(
		public config: ConfigProvider,
		public http: HttpClient
	) {
	}
	/*
	Responsabilità: Aggiunge uno o più ruoli per un utente a un condominio
	*/
	public addCondominiumRoles(user: User, condominium: Condominium, roles: Array<string>) {
		let self = this
		return new Promise<any>((resolve, reject) => {
			if(!user) {
				reject('Utente nullo: Impossibile associarla')
				return
			}
			if(!user.id) {
				console.error('Utente senza ID', user)
				reject('Utente senza ID')
				return
			}

			if(!condominium) {
				reject('Condominio nullo: Impossibile associarla')
				return
			}
			if(!condominium.id) {
				console.error('Condominio senza ID', condominium)
				reject('Condominio senza ID')
				return
			}

			let params = new HttpParams()
			for(let role of roles) {
				params = params.append(role, '1')
			}

			let request = self.http.post(ConfigProvider.HOST + '/condominium/' + condominium.id + '/user/' + user.id + '/store', params)
			request.subscribe(
				(condominiumUser: any) => {
					if(!condominiumUser || !condominiumUser.user_id || !condominiumUser.condominium_id) {//Chiamata ok ma non ha trovato l'utente
						console.log("Associazione condominio * utente fallita", user)
						reject(condominiumUser)
						return
					}
					console.log("Associazione unità condominio * utente creata o aggiornata", user)
					//this.init(user);
					resolve(condominiumUser)
				}, error => {
					console.error("Errore associando condominio * utente", error)
					reject(error)
				})
		})
	}

	/*
	Responsabilità:Aggiunge uno o più ruoli per un utente a un'unità abitativa
	*/
	public addHousingUnitRoles(user: User, housingUnit: HousingUnit, roles: Array<string>) {
		let self = this
		return new Promise<any>((resolve, reject) => {
			if(!user) {
				reject('Utente nullo: Impossibile associarla')
				return
			}
			if(!user.id) {
				console.error('Utente senza ID', user)
				reject('Utente senza ID')
				return
			}

			if(!housingUnit) {
				reject('Unità abitativa nulla: Impossibile associarla')
				return
			}
			if(!housingUnit.id) {
				console.error('Unità abitativa senza ID', housingUnit)
				reject('Unità abitativa senza ID')
				return
			}

			let params = new HttpParams()
			for(let role of roles) {
				params = params.append(role, '1')
			}

			let request = self.http.post(ConfigProvider.HOST + '/housing-unit/' + housingUnit.id + '/user/' + user.id + '/store', params)
			request.subscribe(
				(housiungUnitUser: any) => {
					if(!housiungUnitUser || !housiungUnitUser.user_id || !housiungUnitUser.housing_unit_id) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Associazione unità abitativa * utente fallita", user)
						reject(housiungUnitUser)
						return
					}
					//this.init(user);
					resolve(housiungUnitUser)
				}, error => {
					console.error("Errore creando l'associazione unità abitativa * utente", error)
					reject(error)
				})
		})
	}

	public detachCondominiumRole(condominiumUserPivot: any, role: string): Promise<boolean> {
		console.log('Disassociando ruolo, pivot: ', condominiumUserPivot)
		console.log('Disassociando ruolo, role: ' + role)

		//console.log('Proprietari attuali: '+matchingOwners);
		//console.log('Residenti attuali: '+matchingResidents);

		let condominiumUser = { ...condominiumUserPivot }//Clono per non modificare l'originale in caso di errori

		condominiumUser[role] = false

		let url = ConfigProvider.HOST + "/condominium-user/" + condominiumUser.id + "/update"

		let request = this.http.post<boolean>(url, condominiumUser)
		let promise = request.toPromise()
		promise.then((success: boolean) => {
			if(success) {
				//console.log("Ruolo rimosso da condominio * utente");
			}
			else {
				console.warn("Errore rimuovendo il ruolo da condominio * utente")
			}
		}).catch((error: any) => {
			console.error("Errore rimuovendo il ruolo da condominio * utente:", error)
		})
		return promise
	}

	public detachHousingUnitRole(housingUnitUserPivot: any, role: string): Promise<boolean> {
		//let matchingOwners=housingUnit.owners.filter(u => u.id == user.id&&u.pivot.role=='owner');
		//let matchingResidents=housingUnit.residents.filter(u => (u.id == user.id&&u.pivot.role=='resident'));
		//console.log('Disassociand da housingUnit:',housingUnit);
		//console.log('Disassociando ruolo, pivot: ',housingUnitUserPivot);
		//console.log('Disassociando ruolo, role: '+role);

		//console.log('Proprietari attuali: '+matchingOwners);
		//console.log('Residenti attuali: '+matchingResidents);

		let housingUnitUser = { ...housingUnitUserPivot }//Clono per non modificare l'originale in caso di errori
		//console.log('Aggiornando housingUnitUser: ',housingUnitUser);

		housingUnitUser[role] = false

		//console.log('Da inviare housingUnitUser aggiornato: ',housingUnitUser);

		let url = ConfigProvider.HOST + "/housing-unit-user/" + housingUnitUser.id + "/update"
		//console.log('URL da chiamare: ',url);

		let request = this.http.post<boolean>(url, housingUnitUser)
		let promise = request.toPromise()
		promise.then((success: boolean) => {
			if(success) {
				//console.log("Ruolo rimosso da unità abitativa * utente");
			}
			else {
				console.warn("Errore rimuovendo il ruolo da unità abitativa * utente")
			}
		}).catch((error: any) => {
			console.error("Errore rimuovendo il ruolo da unità abitativa * utente:", error)
		})
		return promise
	}

	/**
	Recupera l'utente per account (login), opzionalmente reimpostando il token
	*/
	public login(type: AccountType, identifier, secret = null, loads: Array<string> = ['condominiums', 'housingUnits'], remember: boolean = true) {
		let params = new HttpParams().set('identifier', identifier).set('secret', secret)/*.set('notification_id', 'web')*/.set('type', type).set('remember', remember ? '1' : '0')
		return this.getUser(ConfigProvider.HOST + '/user/login', 'POST', loads, params)
	}

	public getByFiscalCode(fiscal_code: string, loads: Array<string> = ['condominiums', 'housingUnits']): Promise<User> {
		return this.getUser(ConfigProvider.HOST + '/user/fiscal_code/' + fiscal_code, 'GET', loads)
	}

	/*
	Recupera un utente per ID e lo inizializza, eventualmente precarica relazioni
	*/
	public getById(id: number, loads: string[] = ['condominiums', 'housingUnits']): Promise<User> {
		if(!id) {
			Logger.error('Si è tentato di caricare un utente senza id', null, 'UserProvider.getById()')
			return Promise.reject('Si è tentato di caricare un utente senza id')
		}

		console.log('Recupero l\'utente con gli attributi:', loads)
		return this.getUser(ConfigProvider.HOST + '/user/' + id, 'GET', loads)
	}

	public getByVatNumber(vat_number: string, loads: Array<string> = ['condominiums', 'housingUnits']): Promise<User> {
		return this.getUser(ConfigProvider.HOST + '/user/vat_number/' + vat_number, 'GET', loads)
	}

	public generatePin(user: User): Promise<number> {
		console.log("Generazione del PIN per l'utente:", user)
		let self = this
		return new Promise<number>((resolve, reject) => {
			let request = self.http.post<number>(ConfigProvider.HOST + "/account/pin/generate/" + user.id, {})
			request.subscribe(
				pin => {
					if(!pin) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("PIN non generato correttamente: ", pin)
					}
					resolve(pin)
					return
				}, error => {
					console.error("Errore generando il PIN per l'utente: ", error)
					reject(error)
				}
			)
		})
	}

	/*
	Responsabilità: Recupera un utente, lo inizializza e restituisce la promise per risolverlo
	Requisiti: può essere usato con qualunque url GET che restituisca un solo utente
	*/
	private getUser(
		url: string,
		method: string = 'GET',
		loads: Array<string> = ['condominiums', 'housingUnits'],
		params: HttpParams = new HttpParams()
	): Promise<User> {
		if(loads && loads.length > 0) {//aggiunge eventuali relazioni da caricare

			for(let load of loads) {
				params = params.append('load[]', load)
			}
		}

		let request = null
		let self = this

		switch(method) {
			case 'GET':
				request = this.http.get<User>(url, { params: params })
				break
			case 'POST':
				request = this.http.post<User>(url, params)
				break
			default:
				console.error("Metodo HTTP non riconosciuto: " + method)
				break
		}

		return new Promise<User>((resolve, reject) => {
			request.subscribe(
				user => {
					if(!user || !user.id) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Utente non trovato tramite URL: " + url)
						resolve(user)
						return
					}
					//console.log("Utente recuperato da URL: "+url,user);
					self.init(user)
					resolve(user)
				}, error => {
					Logger.error("Impossibile recuperare l'utente da URL: " + url, error, 'UserProvider.getUser()')
					console.warn("Impossibile recuperare l'utente da URL: " + url, error)
					reject(error)
				})
		})
	}


	/*
	Elimina un utente.
	*/
	public destroy(user: User): Promise<boolean> {
		console.log("Eliminazione dell'utente:", user)
		let self = this
		return new Promise<boolean>((resolve, _) => {
			let request = self.http.post(ConfigProvider.HOST + "/user/" + user.id + "/destroy", { confirm: true })
			request.subscribe(
				deleted => {
					if(!deleted) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("Utente non trovato: ", user)
						resolve(false)
						return
					}
					//console.log("Utente eliminato");
					resolve(true)
				}, error => {
					console.error("Errore eliminando l'utente: ", error)
					//reject(error);
					resolve(false)
				}
			)
		})
	}


	/*
	Elenca gli utenti, eventualmente filtrandoli per condominio o unità abitativa
	*/
	public index(
		condominium: Condominium = null,
		housingUnit: HousingUnit = null,
		loads: Array<string> = [],
		roles: Array<string> = undefined,
		terms: string = null
	): Promise<User[]> {
		let self = this
		let params = new HttpParams()

		for(let load of loads) {
			params = params.append('load[]', load)
		}

		//eventuali ruoli da caricare

		if(roles) {
			for(let role of roles) {
				params = params.append('roles[]', role)
			}
		}

		if(condominium) {
			params = params.append('condominium_id', '' + condominium.id)
		}

		if(housingUnit) {
			params = params.append('housingUnit_id', '' + housingUnit.id)
		}

		if(terms) {
			params = params.append('terms', terms)
		}

		let request = this.http.get<User[]>(ConfigProvider.HOST + '/user', { params: params })

		return new Promise<User[]>((resolve, reject) => {
			request.subscribe(
				users => {
					if(!users) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Utenti non trovati")
						reject(users)
						return
					}
					//console.log("Elenco utenti recuperato",users);

					for(let i = 0; i < users.length; i++) {
						self.init(users[i])
					}
					resolve(users)
				}, error => {
					console.error("Errore recuperando gli utenti", error)
					reject(error)
				})
		})
	}

	public indexByHousingUnit(housingUnit: HousingUnit, loads: string[] = ['condominiums', 'housingUnits']): Promise<User[]> {
		return this.index(null, housingUnit, loads)
	}

	/*
	Inizializza i dati letti
	*/
	private init(user: User) {

		//inizializza gli utenti del condominio
		if(user.condominiums) {
			for(let i in user.condominiums) {
				let condominium = user.condominiums[i]
				condominium.workers = []
				condominium.administrators = []
				for(let j in condominium.users) {
					let u = condominium.users[j]
					if(u.pivot.is_worker) {
						condominium.workers.push(u)
					}
					if(u.pivot.is_administrator) {
						condominium.administrators.push(u)
					}
					if(u.pivot.is_heatingreader) {
						condominium.heatingreaders.push(u)
					}
				}
			}
		}
		//inizializza gli utenti delle unità immobiliari
		if(user.housing_units) {
			for(let i in user.housing_units) {
				let unit = user.housing_units[i]
				unit.owners = []
				unit.residents = []
				for(let j in unit.users) {
					let u = unit.users[j]
					if(u.pivot.is_owner) {
						unit.owners.push(u)
					}
					if(u.pivot.is_resident) {
						unit.residents.push(u)
					}
				}
			}
		}
	}


	public notify(user_id: string | number, message: SignalingMessage) {
		let self = this

		return new Promise<SignalingMessage>((resolve, reject) => {
			let params = new HttpParams()
			for(let property in message) {
				if(message.hasOwnProperty(property) && message[property] !== null) {
					let value = message[property]

					//fix conversione formato date
					let isValidDate=(v:any)=>v && Object.prototype.toString.call(v) === "[object Date]" && !isNaN(v)
					if(isValidDate(value)) {
						value = value.toISOString()
					}
					params = params.append(property, value)
				}
			}
			console.debug("[UserProvider.notify(user_id, message)] Parametri notifica:", params)

			let request = self.http.post<SignalingMessage>(ConfigProvider.HOST + '/user/' + user_id + '/notify', params)
			request.subscribe(
				message => {
					if(!message) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Invio notifica all'app non riuscito")
						reject("Recupero dell'utente fallito")
						return
					}
					//console.log("Utente creato",user);
					//this.init(user)
					resolve(message)
				}, error => {
					console.error("Errore inviando la notifica di PING", error)
					reject(error)
				}
			)
		})
	}

	/*
	Esegue store o update in funzione che l'utente già esista (campo id valorizzato)
	*/
	public save(user: User): Promise<User> {
		if(!user) {
			return Promise.reject('Utente nullo: Impossibile persisterlo')
		}
		if(!user.id) {
			return this.store(user)
		} else {
			return this.update(user)
		}
	}
	/*
	Responsabilità: Crea l'utente
	*/
	public store(user: User, generatePin: boolean = false) {
		let self = this
		return new Promise<User>((resolve, reject) => {
			if(!user) {
				reject('Utente nullo: Impossibile persisterlo')
				return
			}
			if(user.id) {
				console.error('Utente già creato', user)
				reject('Utente già creato')
				return
			}

			let params = new HttpParams()
			for(let property in user) {
				if(property != 'api_token' && user.hasOwnProperty(property) && user[property] !== null) {//api_token forza il login e va gestito da server
					params = params.append(property, user[property])
				}
			}

			if(generatePin) {
				console.log('Creando l\'utente verrà generato un pin')
				params = params.append('generatePin', '1')
			}

			let request = self.http.post<User>(ConfigProvider.HOST + '/user/store', params)
			request.subscribe(
				user => {
					if(!user || !user.id) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Creazione dell'utente fallita", user)
						reject("Creazione dell'utente fallita")
						return
					}
					//console.log("Utente creato",user);
					this.init(user)
					resolve(user)
				}, error => {
					console.error("Errore creando l'utente", error)
					reject(error)
				}
			)
		})
	}
	/*
	Responsabilità: Aggiorna un utente esistente
	*/
	public update(user: User) {
		let self = this
		return new Promise<User>((resolve, reject) => {
			if(!user) {
				reject('Utente nullo: Impossibile persisterlo')
				return
			}
			if(!user.id) {
				console.error('Utente non ancora creato o ID mancante', user)
				reject('Utente non associabile ad uno esistente')
				return
			}

			let params = new HttpParams()
			for(let property in user) {
				if(property != 'api_token' && user.hasOwnProperty(property) && user[property] !== null) {//auth-token verrebbe preso come api login
					console.log('Aggiorno campo utente:' + property)
					params = params.append(property, user[property])
				}
			}

			let request = self.http.post<User>(ConfigProvider.HOST + '/user/' + user.id + '/update', params)
			request.subscribe(
				user => {
					if(!user || !user.id) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Aggiornamento dell'utente fallito", user)
						reject("Aggiornamento dell'utente fallito")
						return
					}
					//console.log("Utente aggiornato",user);
					self.init(user)
					resolve(user)
				}, error => {
					console.error("Errore aggiornando l'utente", error)
					reject(error)
				}
			)
		})
	}
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts